(() => {
  if (window.bjCartFeedbackReady) return;
  window.bjCartFeedbackReady = true;

  const cartUrl = () => `${window.Shopify?.routes?.root || '/'}cart`;
  let readVersion = 0;
  let pendingRead;
  let toast;
  let toastTimer;

  function renderCount(count) {
    if (!Number.isSafeInteger(count) || count < 0) return false;
    document.querySelectorAll('[data-bj-cart-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
    document.querySelectorAll('.bj3-header__cart').forEach((link) => {
      link.setAttribute('aria-label', `Cart, ${count} ${count === 1 ? 'item' : 'items'}`);
    });
    document.querySelectorAll('[data-bj-cart-menu-count]').forEach((label) => {
      label.textContent = `CART (${count})`;
    });
    return true;
  }

  function responseCount(state) {
    if (Number.isSafeInteger(state?.item_count)) return state.item_count;
    const markup = state?.sections?.['cart-ajax'];
    if (typeof markup !== 'string') return null;
    const html = new DOMParser().parseFromString(markup, 'text/html');
    const value = html.querySelector('.cart__items[data-count]')?.dataset.count;
    return value != null && /^\d+$/.test(value) ? Number(value) : null;
  }

  async function syncCount(state) {
    const version = ++readVersion;
    pendingRead?.abort();
    // Use Shopify's bundled response so the badge updates without a second request.
    if (renderCount(responseCount(state))) return;
    const controller = new AbortController();
    pendingRead = controller;
    try {
      const response = await fetch(`${cartUrl()}.js`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        signal: controller.signal
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (version === readVersion) renderCount(cart.item_count);
    } catch (error) {
      // Keep the last confirmed count; never repeat the add request on a read failure.
      if (error.name !== 'AbortError') console.warn('Cart count refresh unavailable.');
    }
  }

  function dismissToast() {
    clearTimeout(toastTimer);
    if (!toast) return;
    if (toast.contains(document.activeElement)) {
      document.querySelector('.bj3-header__cart')?.focus();
    }
    toast.hidden = true;
  }

  function scheduleDismiss() {
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      if (toast.matches(':hover') || toast.contains(document.activeElement)) return;
      dismissToast();
    }, 8000);
  }

  function showAdded() {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'bj-cart-feedback';
      toast.hidden = true;
      const message = document.createElement('p');
      message.setAttribute('role', 'status');
      message.setAttribute('aria-atomic', 'true');
      const link = document.createElement('a');
      link.href = cartUrl();
      link.textContent = 'View cart';
      const close = document.createElement('button');
      close.type = 'button';
      close.setAttribute('aria-label', 'Dismiss cart notification');
      close.textContent = '×';
      close.addEventListener('click', dismissToast);
      toast.append(message, link, close);
      document.body.append(toast);
      toast.addEventListener('mouseenter', () => clearTimeout(toastTimer));
      toast.addEventListener('focusin', () => clearTimeout(toastTimer));
      toast.addEventListener('mouseleave', scheduleDismiss);
      toast.addEventListener('focusout', scheduleDismiss);
      toast.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') dismissToast();
      });
    }
    toast.hidden = false;
    toast.querySelector('[role="status"]').textContent = '✓ Added to cart';
    scheduleDismiss();
  }

  document.addEventListener('ajaxProduct:added', (event) => {
    syncCount(event.detail?.product);
    showAdded();
  });
  document.addEventListener('cart:updated', (event) => syncCount(event.detail?.cart));
  document.addEventListener('ajaxProduct:error', () => {
    dismissToast();
    syncCount();
  });
  window.addEventListener('pageshow', () => syncCount());
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') syncCount();
  });
  document.addEventListener('shopify:section:load', () => syncCount());
})();
